export const createDropdownOptions = (items) =>
  items.map((item) => ({ key: item, text: item, value: item }));

export const getUniqueValues = (array, field) => [
  ...new Set(array.map((item) => item[field]).filter(Boolean)),
];

export const formatDateTime = (dateString) =>
  dateString ? new Date(dateString).toLocaleString() : "";

export const calculateDuration = (inTime, outTime) => {
  if (!inTime) return "0h 0m 0s";
  const startTime = new Date(inTime);
  const endTime = outTime ? new Date(outTime) : new Date();
  const durationMs = endTime - startTime;
  if (durationMs <= 0) return "0h 0m 0s";

  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};

export const formatPeakHour = (hourlyPeakData) => {
  if (!hourlyPeakData.peakHour || hourlyPeakData.peakHour === "N/A")
    return "N/A";
  const hour = parseInt(hourlyPeakData.peakHour.split(":")[0]);
  const period = hour >= 12 ? "PM" : "AM";
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:00 ${period} (${hourlyPeakData.peakCount} activities)`;
};

export const formatSessionForExport = (session) => [
  session.userName || "",
  session.libraryId || "",
  `${session.program || ""} / ${session.year || ""}`,
  session.purposeOfVisit || "Not specified",
  session.checkInTime || "",
  session.checkOutTime || "Still active",
  session.duration || "",
  session.isActive ? "Active" : "Completed",
];
